/**
 * Top-level deep link registration for native apps.
 * 
 * CRITICAL: This MUST be registered at module load time, not in React hooks.
 * When Safari returns from OAuth, iOS relaunches the app and the deep link
 * event is delivered BEFORE React mounts. If the listener isn't registered
 * at this point, the event is lost forever.
 * 
 * This file is imported at app entry (main.tsx) to ensure the listener
 * exists before any deep links can arrive.
 */

import { App } from '@capacitor/app';
import { isNative } from '@/lib/platform';
import { log } from '@/lib/logger';

if (isNative()) {
  log.debug('DEEPLINK', 'Registering appUrlOpen listener (top-level, module load)');

  App.addListener('appUrlOpen', (event) => {
    if (!event?.url) {
      log.warn('DEEPLINK', 'Received appUrlOpen event but URL is empty');
      return;
    }

    log.debug('DEEPLINK', 'Received:', event.url);

    // Dispatch a custom event that React components can listen to
    // This allows React code to handle the callback while keeping
    // the listener registration at top-level
    window.dispatchEvent(
      new CustomEvent('oauth-callback', { detail: { url: event.url } })
    );
  });

  log.debug('DEEPLINK', 'appUrlOpen listener registered successfully');
} else {
  log.debug('DEEPLINK', 'Skipping deep link registration (web build)');
}
